import { gsap } from 'gsap';

const startsWithVowel = word => /^[aeiou]/i.test(word);

const initWordSwap = (wrapper) => {
	const el = wrapper.querySelector('.word-swap');
	const articleEl = wrapper.querySelector('.word-swap-article');
	const raw = wrapper.dataset.words || '';
	const words = raw.split(',').map(w => w.trim()).filter(Boolean);

	if (!el || words.length === 0) return;

	el.textContent = words[0];
	if (articleEl) articleEl.textContent = startsWithVowel(words[0]) ? 'an' : 'a';

	let current = 0;

	const swap = () => {
		current = (current + 1) % words.length;
		const word = words[current];

		gsap.to(el, {
			opacity: 0,
			y: 20,
			duration: 0.3,
			ease: 'power2.in',
			onComplete: () => {
				el.textContent = word;
				if (articleEl) articleEl.textContent = startsWithVowel(word) ? 'an' : 'a';
				gsap.fromTo(el,
					{ opacity: 0, y: -20 },
					{ opacity: 1, y: 0, duration: 0.4, ease: 'power2.out' }
				);
			}
		});
	};

	setInterval(swap, 5000);
};

document.querySelectorAll('[data-word-swap-wrapper]').forEach(initWordSwap);
